function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { themeSpaces } from '../../../theme/foundations';
var sharedOptionStyles = {
  width: '100%',
  display: 'flex',
  gap: 's',
  alignItems: 'center',
  padding: 's',
  cursor: 'pointer',
  transition: 'background-color 0.1s ease-in-out',
  textStyle: 'body3'
};
var sharedIconStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '&[data-view-mode="true"]': {
    display: 'none'
  }
};

var getValueRightElementWidth = valueRightElementWidth => valueRightElementWidth ? "calc(".concat(themeSpaces.xs, " + ").concat(valueRightElementWidth, "px)") : '0px';

export var baseSelectTheme = {
  baseStyle: _ref => {
    var {
      isOpen,
      shouldShowCreatableOption,
      strategy,
      x,
      y,
      clickableEmptyState,
      hasLeftElement,
      isViewMode,
      valueRightElementWidth = 0,
      placeholderValue
    } = _ref;
    return {
      container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      },
      triggerInput: {
        position: 'absolute',
        inset: '0',
        opacity: '0',
        cursor: 'pointer'
      },
      trigger: {
        textOverflow: 'ellipsis',
        position: 'relative',
        textAlign: 'start',
        textStyle: 'body2',
        display: 'flex',
        alignItems: 'center',
        // Overrides the input's padding-right.
        paddingRight: isViewMode ? // Using `!important` here to override the input's view-mode selector.
        "".concat(getValueRightElementWidth(valueRightElementWidth), " !important") : "calc(".concat(themeSpaces.xxl, " + ").concat(getValueRightElementWidth(valueRightElementWidth), ")"),
        _disabled: {
          color: 'neutral.light',
          cursor: 'default'
        },
        '&[data-ui-only="true"]': {
          pointerEvents: 'none'
        }
      },
      toggleButtonRightElement: {
        height: '100%',
        paddingRight: 's',
        pointerEvents: 'none'
      },
      triggerOverlay: {
        paddingLeft: hasLeftElement ? 'l' : 'none',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 'xs',
        position: 'absolute',
        top: 0,
        width: '100%',
        // `triggerOverlay` text color should always be transparent so we only see the input's text.
        color: 'transparent',
        paddingStart: !isViewMode && hasLeftElement ? 'xl' : 's',
        paddingEnd: isViewMode ? undefined : 'xxl',
        textStyle: 'body2',
        height: '100%'
      },
      valueRightElement: {
        display: 'inline-flex'
      },
      triggerLeftIcon: _objectSpread(_objectSpread({}, sharedIconStyles), {}, {
        paddingRight: 'xs',
        paddingLeft: 's',
        _readOnly: {
          color: 'neutral.light'
        }
      }),
      triggerRightIcon: _objectSpread(_objectSpread({}, sharedIconStyles), {}, {
        height: 'auto',
        _disabled: {
          color: 'neutral.light',
          cursor: 'default'
        },
        _readOnly: {
          color: 'neutral.light',
          cursor: 'default'
        }
      }),
      placeholder: {
        color: 'neutral.dark',
        display: 'flex',
        minWidth: 0,
        _disabled: {
          color: 'neutral.light'
        },
        // Using CSS pseudo element because placeholder should be ignored by a11y tools.
        '::after': {
          content: "\"".concat(placeholderValue, "\""),
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      dropdownMenu: {
        visibility: isOpen ? 'visible' : 'hidden',
        zIndex: 'popover',
        position: strategy,
        top: "".concat(y !== null && y !== void 0 ? y : 0, "px"),
        left: "".concat(x !== null && x !== void 0 ? x : 0, "px")
      },
      dropdownMenuContent: {
        textStyle: 'body4Semi',
        borderRadius: 'l',
        boxShadow: 500,
        border: 'surface.default',
        backgroundColor: 'neutral.white',
        overflow: 'hidden',
        paddingTop: 'xs',
        paddingBottom: shouldShowCreatableOption ? 'none' : 'xs',
        marginTop: 'xs'
      },
      optionsContainer: {
        maxHeight: '248px',
        overflowY: 'auto',
        overflowX: 'hidden',
        textStyle: 'body3',
        _hover: {
          outline: 'none'
        }
      },
      sectionLabel: {
        padding: 's'
      },
      option: _objectSpread(_objectSpread({}, sharedOptionStyles), {}, {
        color: 'neutral.black',
        _hover: {
          backgroundColor: 'neutral.lightest'
        },
        _active: {
          backgroundColor: 'neutral.lightest'
        }
      }),
      checkedIcon: {
        display: 'inline-flex',
        marginLeft: 'auto',
        flexShrink: 0
      },
      creatableOption: _objectSpread(_objectSpread({}, sharedOptionStyles), {}, {
        color: 'neutral.black',
        _hover: {
          backgroundColor: 'neutral.lightest'
        },
        _active: {
          backgroundColor: 'neutral.lightest'
        }
      }),
      emptyState: _objectSpread(_objectSpread({}, sharedOptionStyles), {}, {
        justifyContent: clickableEmptyState ? 'flex-start' : 'center',
        color: 'neutral.darker',
        _hover: {
          backgroundColor: clickableEmptyState ? 'none' : 'neutral.lightest'
        },
        _active: {
          backgroundColor: clickableEmptyState ? 'none' : 'neutral.lightest'
        },
        _disabled: {
          pointerEvents: 'none'
        }
      }),
      loading: _objectSpread(_objectSpread({}, sharedOptionStyles), {}, {
        justifyContent: 'center',
        color: 'neutral.darker',
        pointerEvents: 'none'
      })
    };
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=BaseSelect.theme.js.map